// extracted by mini-css-extract-plugin
export default {"root":"SystemStatusCard_root__r2uHh"};